{
  "welcome": {
    "title": "Vitajte v",
    "subtitle": "Váš fitness asistent poháňaný umelou inteligenciou. Získajte personalizované tréningy, výživové plány a odborné vedenie."
  },
  "cta": {
    "title": "Pripravený začať?",
    "subtitle": "Pridajte sa k tisícom užívateľov, ktorí transformujú svoju fitnes cestu s AI."
  },
  "buttons": {
    "signIn": "Prihlásiť sa",
    "signUp": "Registrovať sa",
    "signUpFree": "Registrovať sa zadarmo",
    "learnMore": "Zistiť viac"
  },
  "trust": {
    "subtitle": "Dôverujú nám fitness nadšenci po celom svete",
    "badges": {
      "ai": "AI",
      "fit": "FIT",
      "smart": "SMART"
    }
  },
  "footer": {
    "copyright": "© 2025 Fytness. Všetky práva vyhradené.",
    "privacyPolicy": "Ochrana súkromia",
    "termsOfService": "Podmienky služby",
    "contact": "Kontakt"
  },
  "brand": {
    "name": "Fytness"
  }
}
